import { Box, Container, Typography } from "@mui/material";
import heroImg from "../../assets/about/heroBanner.png";

const HeroBanner = ({
  title,
  subtitle,
  image = heroImg,
  align = "left",
  height = { xs: 300, md: 300 },
}) => {
  const isCenter = align === "center";

  return (
    <Box sx={(theme) => styles.hero(theme, image, height)}>
      <Box sx={styles.overlayPattern} />

      <Container maxWidth="lg" sx={styles.container(isCenter, height)}>
        <Typography variant="h3" sx={styles.heading}>
          {title}
        </Typography>

        {subtitle && <Typography sx={styles.subtitle}>{subtitle}</Typography>}
      </Container>

      <Box sx={styles.softGlow} />
      <Box sx={styles.bottomFade} />
    </Box>
  );
};

const styles = {
  hero: (theme, image, height) => ({
    position: "relative",
    minHeight: height,
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    backgroundImage: `
      linear-gradient(
        90deg,
        rgba(7, 21, 37, 0.94) 0%,
        rgba(7, 21, 37, 0.78) 45%,
        rgba(7, 21, 37, 0.35) 100%
      ),
      url(${image})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }),

  container: (isCenter, height) => ({
    position: "relative",
    zIndex: 3,
    minHeight: height,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: {
      xs: "center",
      md: isCenter ? "center" : "flex-start",
    },
    textAlign: {
      xs: "center",
      md: isCenter ? "center" : "left",
    },
  }),

  heading: {
    color: "#fff",
    fontWeight: 800,
    lineHeight: 1.15,
    fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
    letterSpacing: "-1px",
  },

  subtitle: {
    mt: 2,
    maxWidth: 870,
    color: "rgba(255,255,255,0.78)",
    fontSize: { xs: "0.95rem", md: "1.2rem" },
    lineHeight: 1.7,
  },

  overlayPattern: {
    position: "absolute",
    inset: 0,
    zIndex: 1,
    opacity: 0.18,
    backgroundImage: `
      linear-gradient(rgba(255,255,255,0.08) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,255,255,0.08) 1px, transparent 1px)
    `,
    backgroundSize: "48px 48px",
    maskImage:
      "linear-gradient(90deg, rgba(0,0,0,1), rgba(0,0,0,0.35), transparent)",
    WebkitMaskImage:
      "linear-gradient(90deg, rgba(0,0,0,1), rgba(0,0,0,0.35), transparent)",
  },

  softGlow: {
    position: "absolute",
    zIndex: 1,
    width: { xs: 220, md: 420 },
    height: { xs: 220, md: 420 },
    right: { xs: "-120px", md: "-80px" },
    top: { xs: "-80px", md: "-140px" },
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(0,200,83,0.22), rgba(0,200,83,0.04) 45%, transparent 70%)",
  },

  bottomFade: {
    position: "absolute",
    zIndex: 2,
    left: 0,
    right: 0,
    bottom: 0,
    height: "35%",
    background: "linear-gradient(to top, rgba(7,21,37,0.9), transparent)",
  },
};

export default HeroBanner;
